import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import  moment from 'moment';

@Injectable()
export class Api {
    constructor(private httpClient: HttpClient) {

    }

    protected convertDateTimeToIsoString(params?: HttpParams) {
      for(var key in params) {
        if (moment.isMoment(params[key])) {
          params[key] = params[key].utc(true).toISOString();
        }
      }
      return params;
    }

    private buildUrl(isUseGobalErrorHandler: boolean, action: string, params?: HttpParams) {
        params = this.convertDateTimeToIsoString(params);
        if (params && !(params instanceof HttpParams)) {
            var data = new HttpParams();
            Object.keys(params).forEach(function (key) {
                if (params[key] 
                    && (params[key].length === undefined || params[key].length > 0)) {
                    if (!Array.isArray(params[key])) {
                        data = data.set(key, params[key]);
                    } else {
                        // Valid format for array param ids=1&ids=2&ids=3
                        // Invalid format ids=1,2,3 
                        params[key].forEach(item => {
                            data = data.append(key, item);
                        });
                    }
                    
                }
            });

            params = data;
        }

        let url = `${environment.apiUrl}/${action}`
            + (params != null ? `?${params.toString()}` : '')
            + `#${isUseGobalErrorHandler}`;
        return url;
    }

    get<T>(action: string, params?: HttpParams, isUseGobalErrorHandler: boolean = true): Observable<T> {
        let url = this.buildUrl(isUseGobalErrorHandler, action, params);
        return this.httpClient.get<T>(url, { params: params });
    }

    post(action: string, body: any, options?: any, isUseGobalErrorHandler: boolean = true): Observable<Object> {
        let url = this.buildUrl(isUseGobalErrorHandler, action, null);
        return this.httpClient.post(url, body, options);
    }

    put(action: string, body: any, isUseGobalErrorHandler: boolean = true): Observable<Object> {
        let url = this.buildUrl(isUseGobalErrorHandler, action, null);
        return this.httpClient.put(url, body);
    }

    delete(action: string, param: any, isUseGobalErrorHandler: boolean = true): Observable<Object> {

        let url = this.buildUrl(isUseGobalErrorHandler, action, param);
        return this.httpClient.delete(url);
    }

    download<T>(filename: string, action: string, params?: HttpParams): Observable<any> {
        return this.httpClient.get(`${environment.apiUrl}/${action}`, { responseType: 'blob', observe: 'response' })
            .pipe(map((result: any) => {
                if (filename === '') {
                    const contentDisposition = result.headers.get('content-disposition') || '';
                    const patt = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const regex = contentDisposition.match(patt);
                    filename = regex[1].replace(/['"]/g, '');
                }
                const file = new Blob([result.body], { type: result.headers.get('Content-Type') });
                const downloadUrl = window.URL.createObjectURL(file);
                const fileLink = document.createElement('a');
                fileLink.href = downloadUrl;
                fileLink.download = filename;
                document.body.appendChild(fileLink);
                fileLink.click();
                setTimeout(function () {
                    document.body.removeChild(fileLink);
                    window.URL.revokeObjectURL(downloadUrl);
                }, 100);
            }));
    }

    downloadPdf(action: string): Observable<HttpResponse<Blob>> {
        let headers = new HttpHeaders();
        headers = headers.append('Accept', 'application/pdf');
        return this.httpClient.get(`${environment.apiUrl}/${action}`, {
            headers: headers,
            observe: 'response',
            responseType: 'blob',
        });
    }
}
